import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const OPTS = [["not_started", "Not Started"], ["in_progress", "In Process"], ["completed", "Completed"]];

/** Candidate's single status control — same task record and rules as the district task list. */
export function PortalStatusSelect({ taskId, status, needsUpload, onChanged }) {
  const [busy, setBusy] = useState(false);
  const cur = ["in_progress", "completed"].includes(status) ? status : "not_started";
  const send = async (v) => {
    if (v === cur) return;
    if (v === "completed" && needsUpload) { toast.error("Upload the required document to submit this task."); return; }
    setBusy(true);
    try {
      await (v === "completed" ? api.post(`/portal/tasks/${taskId}/complete`) : api.post(`/portal/tasks/${taskId}/progress`, { status: v }));
      toast.success(`Status: ${OPTS.find((o) => o[0] === v)[1]}`); onChanged?.();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <Select value={cur} disabled={busy || cur === "completed"} onValueChange={send}>
      <SelectTrigger className="h-9 w-40 text-sm" data-testid="portal-status-select"><SelectValue /></SelectTrigger>
      <SelectContent className="bg-white">{OPTS.map(([k, l]) => <SelectItem key={k} value={k} data-testid={`portal-status-opt-${k}`}>{l}</SelectItem>)}</SelectContent>
    </Select>
  );
}
